import React from "react";
import {
  SEO,
  MarkdownContent,
  VideoPlayer,
  DynamicForm,
  InternalLink,
  OutboundLink,
} from "@bluefin/components";
import { Grid, Segment, Checkbox } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  getComponentConfigurationData,
} from "../utils/utils";

export default class CourseRegistrationPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      ocebeglgpncbfbncjhjcmaiodaadihamoceb,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.bellamiacademie.com/course-registration/"}
        />
        <Grid className={"custom-page-grid"} style={{}} stackable={true}>
          <Grid.Row className={""} style={{ padding: 0 }} textAlign={"center"}>
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              width={10}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "049af932-6d25-47ed-a864-c08c707e740b",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"mdcloaediopgegkc"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
            columns={2}
          >
            <Grid.Column
              className={"fblckajlbnbmeacm"}
              style={{ padding: 16 }}
              textAlign={"justified"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "b547d569-5322-4e05-95a3-1e2510ee3870",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"eaoolaafegdieomi"}
              style={{ padding: 16 }}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <VideoPlayer
                  className={"video-block"}
                  style={{}}
                  url={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "42f1c219-f60a-4d2f-9c59-bf261757a33d",
                    dataPath: "data.video.url",
                  })}
                  videoId={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "42f1c219-f60a-4d2f-9c59-bf261757a33d",
                    dataPath: "data.video.videoId",
                  })}
                  source={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "42f1c219-f60a-4d2f-9c59-bf261757a33d",
                    dataPath: "data.video.source",
                  })}
                  placeholder={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "42f1c219-f60a-4d2f-9c59-bf261757a33d",
                    dataPath: "data.video.placeholder",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className={""} style={{ padding: 16 }} columns={0} />
          <Grid.Row className={""} style={{ padding: 0 }} textAlign={"center"}>
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={1399}
                  businessInfoId={6579}
                  websiteId={7642}
                  locationId={1470}
                  componentConfigurationId={43797}
                  header={ocebeglgpncbfbncjhjcmaiodaadihamoceb.data.header}
                  fields={
                    ocebeglgpncbfbncjhjcmaiodaadihamoceb.data.dynamicFormFields
                  }
                  consentSettings={
                    ocebeglgpncbfbncjhjcmaiodaadihamoceb.data.consentSettings
                  }
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"dfrhrolxzptloxnp"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"ksinuasccjsuhsiu"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__d78ed01e-d54e-4735-8d8e-86050e8161cd"}
                >
                  <div className={"custom-tos-container"}>
                    <div>
                      <Checkbox
                        label={
                          "I consent to receive sms notifications, alerts from BellaMi Academie. Message frequency varies. Message & data rates may apply. Text HELP to (848) 800-4949 for assistance. You can reply STOP to unsubscribe at any time."
                        }
                      />
                      <Checkbox
                        label={
                          "By checking this box I agree to receive occasional marketing messages from BellaMi Academie."
                        }
                      />
                    </div>
                    <InternalLink to={"/terms-and-conditions/"}>
                      Terms of Service
                    </InternalLink>
                    <span>&nbsp;& &nbsp;</span>
                    <OutboundLink
                      to={
                        "https://fisherman-static.s3.amazonaws.com/public/__fisherman/Client+Website+Privacy+Policy.pdf"
                      }
                    >
                      Privacy Policy
                    </OutboundLink>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 23642 }) {
      title
      seoTitle
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
        data {
          video {
            url
            source
            videoId
            placeholder
          }
        }
      }
    }
    ocebeglgpncbfbncjhjcmaiodaadihamoceb: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "ebf6f67a-fe22-41ca-8eca-10c116334b34" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          style {
            color
            marginTop
            marginBottom
          }
          content
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
        consentSettings {
          show
          required
        }
      }
    }
  }
`;
